import * as _ from "lodash-es";

export const MAX_PAGE_SIZE = 1000;
export const INTERVIEW_DURATION_OPTIONS = [10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60];
export const PARENTS_INTERVIEW_DURATION_OPTIONS = [
  10, 15, 20, 25, 30, 35, 40, 45, 50, 55,
];

export const AUSTRALIA_STATES = [
  { text: "ACT", value: "ACT" },
  { text: "NSW", value: "NSW" },
  { text: "VIC", value: "VIC" },
  { text: "TAS", value: "TAS" },
  { text: "QLD", value: "QLD" },
  { text: "WA", value: "WA" },
  { text: "SA", value: "SA" },
  { text: "NT", value: "NT" },
];

export const RELATIONSHIP_MOTHER = 0;
export const RELATIONSHIP_FATHER = 1;
export const RELATIONSHIP_STEPMOTHER = 4;
export const RELATIONSHIP_STEPFATHER = 5;
export const RELATIONSHIPS = [
  { text: "Mother", value: RELATIONSHIP_MOTHER },
  { text: "Father", value: RELATIONSHIP_FATHER },
  { text: "Stepmother / De facto Stepmother", value: RELATIONSHIP_STEPMOTHER },
  { text: "Stepfather / De facto Stepfather", value: RELATIONSHIP_STEPFATHER },
  { text: "Guardian/Carer", value: 2 },
];

export const ABORIGINAL_STATUS_NO = 0;
export const ABORIGINAL_STATUS_YES = 1;
export const ABORIGINAL_STATUS_YES_TORRES_STRAIT_ISLANDER = 2;
export const ABORIGINAL_STATUSES_OPTIONS = [
  { value: ABORIGINAL_STATUS_NO, text: "No" },
  { value: ABORIGINAL_STATUS_YES, text: "Yes, Aboriginal Background" },
  {
    value: ABORIGINAL_STATUS_YES_TORRES_STRAIT_ISLANDER,
    text: "Yes, Torres Strait Islander Background",
  },
];

export const MALE = 1;
export const FEMALE = 2;
export const OTHER_GENDER = 3;
export const ALUMNUS_FEMALE_CONNECTION_TYPE_CHOICES = [
  { value: "GRANDMOTHER", text: "Grandmother" },
  { value: "GREAT_GRANDMOTHER", text: "Great Grandmother" },
  { value: "AUNT", text: "Aunt" },
  { value: "SISTER", text: "Sister" },
];
export const ALUMNUS_MALE_CONNECTION_TYPE_CHOICES = [
  { value: "GRANDFATHER", text: "Grandfather" },
  { value: "GREAT_GRANDFATHER", text: "Great Grandfather" },
  { value: "UNCLE", text: "Uncle" },
  { value: "BROTHER", text: "Brother" },
];
export const ALUMNUS_COMMON_CONNECTION_TYPE_CHOICES = [
  { value: "COUSIN", text: "Cousin" },
];
export const ALUMNUS_OTHER_CONNECTION_TYPE_CHOICES = [{ value: "OTHER", text: "Other" }];
export const NON_PARENT_ALUMNUS_CONNECTION_TYPE_CHOICES = [
  ...ALUMNUS_FEMALE_CONNECTION_TYPE_CHOICES,
  ...ALUMNUS_MALE_CONNECTION_TYPE_CHOICES,
  ...ALUMNUS_COMMON_CONNECTION_TYPE_CHOICES,
  ...ALUMNUS_OTHER_CONNECTION_TYPE_CHOICES,
];
export const FATHER_CONNECTION = { value: "FATHER", text: "Father" };
export const MOTHER_CONNECTION = { value: "MOTHER", text: "Mother" };
export const STEPMOTHER_CONNECTION = { value: "STEPMOTHER", text: "Stepmother" };
export const STEPFATHER_CONNECTION = { value: "STEPFATHER", text: "Stepfather" };
export const PARENT_CONNECTION_TYPE_CHOICES = [
  MOTHER_CONNECTION,
  FATHER_CONNECTION,
  STEPMOTHER_CONNECTION,
  STEPFATHER_CONNECTION,
];
export const FEMALE_CONNECTION_TYPES = [
  ...ALUMNUS_FEMALE_CONNECTION_TYPE_CHOICES,
  MOTHER_CONNECTION,
  STEPMOTHER_CONNECTION,
  ...ALUMNUS_COMMON_CONNECTION_TYPE_CHOICES,
].map((c) => c.value);
export const ALL_CONNECTION_TYPE_CHOICES = [
  ...PARENT_CONNECTION_TYPE_CHOICES,
  ...NON_PARENT_ALUMNUS_CONNECTION_TYPE_CHOICES,
];
export const RELATIONSHIP_TO_ALUMNUS_CONNECTION_TYPE = {
  [RELATIONSHIP_MOTHER]: MOTHER_CONNECTION.value,
  [RELATIONSHIP_FATHER]: FATHER_CONNECTION.value,
  [RELATIONSHIP_STEPMOTHER]: STEPMOTHER_CONNECTION.value,
  [RELATIONSHIP_STEPFATHER]: STEPFATHER_CONNECTION.value,
};

export const RESIDENCY_STATUS = {
  CITIZEN: 0,
  PERMANENT_RESIDENT: 1,
  TEMPORARY_RESIDENT: 2,
  NON_RESIDENT: 3,
};

export const RESIDES_WITH_BOTH_PARENTS = 0;
export const RESIDES_WITH_OTHER = 4;
export const RESIDES_CHOICES = [
  { text: "Both Parents Together", value: RESIDES_WITH_BOTH_PARENTS },
  { text: "Both Parents - Shared Arrangement", value: 6 },
  { text: "Mother", value: 1 },
  { text: "Father", value: 2 },
  { text: "Guardian/Carer", value: 3 },
  { text: "Other", value: RESIDES_WITH_OTHER },
];

export const HIGHEST_SCHOOL_YEAR_CHOICES = [
  { value: 1, text: "Year 9 or below" },
  { value: 2, text: "Year 10" },
  { value: 3, text: "Year 11" },
  { value: 4, text: "Year 12" },
];
export const DEGREE_CHOICES = [
  { value: 7, text: "Bachelor Degree or Above" },
  { value: 6, text: "Advanced Diploma/Diploma" },
  { value: 5, text: "Certificate I to IV" },
  { value: 8, text: "No non-school qualification" },
];

export const OTHER_SOCICAL_UNIT_OPTION = {
  id: "bc20de64-3afb-4490-8811-d787a5ddabba",
  name: "Other",
};
export const OTHER_SCHOOL_OPTION = { id: -1, name: "Other" };
export const NOT_AT_SCHOOL_OPTION = { id: -2, name: "Not Currently at School" };
export const OTHER_LANGUAGE = {
  id: "9144b8e1-56fa-49a8-9e4e-58b116885426",
  name: "Other",
  ascl_id: 1000,
};
export const AUSTRALIA = {
  id: 36,
  alpha_2_code: "AU",
  alpha_3_code: "AUS",
  name: "Australia",
};

export const DEFAULT_ATTENDEES_LIMIT_PER_BOOKING = 10;
export const ATTENDEE_KINDS = {
  USER_PARENT: { value: "USER_PARENT", text: "Parent 1" },
  NON_USER_PARENT: { value: "NON_USER_PARENT", text: "Parent 2" },
};

export const MAX_EOI_STEP = 9;
export const MAX_ENROLMENT_STEP = 9;

export const ENROLMENT_STEP_ABILITIES = 4;
export const ENROLMENT_STEP_QUESTIONNAIRE = 5;
export const ENROLMENT_STEP_BILLING = 6;

export const EMAIL_TEMPLATE_KINDS = {
  MARKETING: "MARKETING",
  CUSTOM: "CUSTOM",
  ENROLMENT_INVITE_PARENT: "ENROLMENT_INVITE_PARENT",
  ENROLMENT_DECLINE_STUDENT_BY_STAFF_PARENT: "ENROLMENT_DECLINE_STUDENT_BY_STAFF_PARENT",
  ENROLMENT_DECLINE_STUDENT_BY_PARENT_PARENT:
    "ENROLMENT_DECLINE_STUDENT_BY_PARENT_PARENT",
  ENROLMENT_MAKE_OFFER_PARENT: "ENROLMENT_MAKE_OFFER_PARENT",
  ENROLMENT_OFFER_ACCEPTED_STAFF: "ENROLMENT_OFFER_ACCEPTED_STAFF",
  RESERVED_PLACE_MAKE_OFFER_PARENT: "RESERVED_PLACE_MAKE_OFFER_PARENT",
  RESERVED_PLACE_OFFER_ACCEPTED_STAFF: "RESERVED_PLACE_OFFER_ACCEPTED_STAFF",
  ENROLMENT_REQUEST_DOCUMENTS_PARENT: "ENROLMENT_REQUEST_DOCUMENTS_PARENT",
  INTERVIEW_INVITE_PARENT: "INTERVIEW_INVITE_PARENT",
  ENROLMENT_REQUEST_NON_USER_PARENT_ACCEPTANCE:
    "ENROLMENT_REQUEST_NON_USER_PARENT_ACCEPTANCE",
  GPA_REQUEST_NON_USER_PARENT_ACCEPTANCE: "GPA_REQUEST_NON_USER_PARENT_ACCEPTANCE",
};

export const OFFER_KINDS = {
  ENROLMENT: "enrolment_offer",
  RESERVED_PLACE: "reserved_place_offer",
};

export const SCHOOL_LEVEL_LABELS = ["Year", "Grade", "Class"];

export const ENTRY_GRADES = {
  NOT_AT_SCHOOL: -4,
  PRESCHOOL: -1,
  KINDERGARTEN: 0,
};

export const GRID_BREAKPOINTS = {
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
};

export const ACADEMIC_TERM_CHOICES = [
  { value: 1, text: "Term 1" },
  { value: 2, text: "Term 2" },
  { value: 3, text: "Term 3" },
  { value: 4, text: "Term 4" },
];

export const USER_KIND_STAFF = "STAFF";
export const USER_KIND_PARENT = "PARENT";
export const USER_KIND_VOLUNTEER = "VOLUNTEER";
export const UI_KIND_UNKNOWN = "UNKNOWN";

export const MONTHES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const PREVIEW_IMAGE_FORMATS = [
  "image/png",
  "image/jpeg",
  "image/bmp",
  "image/webp",
];
export const PREVIEW_IMAGE_EXTENSIONS = ["png", "jpeg", "jpg", "bmp", "webp", "jfif"];
export const IMAGE_EXTENSIONS = [...PREVIEW_IMAGE_EXTENSIONS, "tiff"];
const VIDEO_EXTENSIONS = ["mp4"];
export const DOCUMENT_EXTENSIONS = [
  "doc",
  "docx",
  "odt",
  "pdf",
  "rtf",
  "txt",
  "xls",
  "xlsx",
  ...IMAGE_EXTENSIONS,
  ...VIDEO_EXTENSIONS,
];
export const PHOTO_ID_ACCEPT_EXTENSIONS = "image/*,.pdf";

const year = new Date().getFullYear();
export const ENTRY_YEAR_RANGE = _.range(year, year + 15);
// Staff should see/select old values in dashboard.
export const STAFF_ENTRY_YEAR_RANGE = _.range(2014, year + 15);

// Most popular http error codes for our app.
export const HTTP_ERROR_CODES_MAP = {
  400: "Form Has Errors",
  401: "Unauthorized",
  403: "Forbidden",
  404: "Not Found",
  405: "Method Not Allowed",
  // We have a `client_max_body_size` limit on file upload size in nginx. This limitation works before the django backend and we
  // don't need to add a size validation to the backend.
  // Note: This message should also be changed after changing the file size limit in nginx.
  413: "Ensure file size is less than 100 MB.",
  500: "Internal Server Error",
};

export const NOTIFICATION_TOAST_VARIANTS_MAP = {
  success: "success",
  warn: "warning",
  warning: "warning",
  error: "danger",
};

export const DOCUMENT_KINDS = {
  INNER: "INNER",
  CUSTODY: "CUSTODY",
  PASSPORT: "PASSPORT",
  VISA: "VISA",
  AUSTRALIAN_PASSPORT: "AUSTRALIAN_PASSPORT",
  PARENT_AUSTRALIAN_PASSPORT: "PARENT_AUSTRALIAN_PASSPORT",
  BIRTH_CERT: "BIRTH_CERT",
  IHS: "IHS",
  SCHOOL_REPORT: "SCHOOL_REPORT",
  NAPLAN: "NAPLAN",
  ASSESSMENT: "ASSESSMENT",
  SYLLABUS: "SYLLABUS",
  CUSTOM_1: "CUSTOM_1",
  CUSTOM_2: "CUSTOM_2",
  CUSTOM_3: "CUSTOM_3",
  CUSTOM_4: "CUSTOM_4",
  CUSTOM_5: "CUSTOM_5",
  ENRICHMENT: "ENRICHMENT",
  MUSIC: "MUSIC",
  SPORT: "SPORT",
  CUSTOM_ABILITIES_1: "CUSTOM_ABILITIES_1",
  CUSTOM_ABILITIES_2: "CUSTOM_ABILITIES_2",
  CUSTOM_ABILITIES_3: "CUSTOM_ABILITIES_3",
  SUPPORTING_MEDICAL: "SUPPORTING_MEDICAL",
  PARENT_HEALTH_CARE_CARD: "PARENT_HEALTH_CARE_CARD",
  BAPTISMAL_CERT: "BAPTISMAL_CERT",
  CUSTOM_FORM: "CUSTOM_FORM",
  DIAGNOSIS: "DIAGNOSIS",
  IEP: "IEP",
  STAFF_ONLY: "STAFF_ONLY",
  AUTHORISED_STAFF_ONLY: "AUTHORISED_STAFF_ONLY",
  SYSTEM: "SYSTEM",
  PAYER_IDENTIFICATION: "PAYER_IDENTIFICATION",
};

// Keep in sync with DocumentGroupKind.is_verifiable
export const DOCUMENTS_WITH_VERIFICATION = Object.values(DOCUMENT_KINDS).filter(
  (k) =>
    ![
      DOCUMENT_KINDS.INNER,
      DOCUMENT_KINDS.STAFF_ONLY,
      DOCUMENT_KINDS.AUTHORISED_STAFF_ONLY,
      DOCUMENT_KINDS.SYSTEM,
    ].includes(k),
);

export const OTP_BACKENDS = {
  EMAIL: "EMAIL",
  MOBILE_PHONE: "MOBILE_PHONE",
};

export const YES_NO_OPTIONS = [
  { value: true, text: "Yes" },
  { value: false, text: "No" },
];

export const NULL_YES_OPTIONS = [
  { value: null, text: "No" },
  { value: true, text: "Yes" },
];

export const MULTISELECT_NO_OPTIONS =
  "Type to start searching. No matching results have been found yet.";

export const LEAD_STATUS = {
  NEW: 0,
  PROFILE_CREATED: 1,
  PROFILE_CREATION_FAILED: 2,
  PROFILE_ALREADY_EXISTS: 3,
};

export const LEAD_STATUS_LABELS_MAP = {
  [LEAD_STATUS.NEW]: "New",
  [LEAD_STATUS.PROFILE_CREATED]: "Profile created",
  [LEAD_STATUS.PROFILE_CREATION_FAILED]: "Profile creation failed",
  [LEAD_STATUS.PROFILE_ALREADY_EXISTS]: "Profile already exists",
};

export const LEAD_STATUS_OPTIONS = Object.values(LEAD_STATUS).map((value) => ({
  value,
  text: LEAD_STATUS_LABELS_MAP[value],
}));

export const PAYERS = {
  FIRST_PARENT: 0,
  SECOND_PARENT: 1,
  GUARDIAN: 2,
  OTHER: 3,
  BOTH_PARENTS: 4,
};

export const PAYERS_LABELS = {
  [PAYERS.FIRST_PARENT]: "Parent 1",
  [PAYERS.SECOND_PARENT]: "Parent 2",
  [PAYERS.BOTH_PARENTS]: "Both Parents",
  [PAYERS.GUARDIAN]: "Guardian",
  [PAYERS.OTHER]: "Other",
};

export const PAYERS_OPTIONS = Object.entries(PAYERS_LABELS).map(([k, v]) => ({
  value: parseInt(k, 10),
  text: v,
}));

// Keep in sync with AcceptanceLabels
export const LABELS_FOR_ACCEPT = {
  ACCEPT: "Accept",
  CONFIRM: "Confirm",
};

export const LABELS_FOR_ACCEPTANCE_MAP = {
  [LABELS_FOR_ACCEPT.ACCEPT]: "Acceptance",
  [LABELS_FOR_ACCEPT.CONFIRM]: "Confirmation",
};
